import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Resolve,
  RouterStateSnapshot
} from '@angular/router';

import { Observable } from 'rxjs';

import { TranslationService } from './../services/translation.service';

@Injectable()
export class TranslationResolver implements Resolve<boolean> {
  constructor(private translationService: TranslationService) {}

  public resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.translationService.languageLoaded;
  }
}
